// extracted by mini-css-extract-plugin
export default {"MainContainer":"MainContainer_MainContainer__SXcJt"};